import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, Input, Output, ContentChild, forwardRef, Directive, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@eui/components/legacy/ux-overlay';
import { UxOverlayComponentModule } from '@eui/components/legacy/ux-overlay';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

class UxFieldsetComponent {
    constructor() {
        this.typeClass = 'default';
        this._isFirst = false;
        this._isLarge = false;
        this._isCompactFields = false;
        this._isVerticalFields = false;
        this._isHighlighted = false;
        this._isExpandable = false;
        this._isExpanded = true;
        this.e2eAttr = 'ux-fieldset';
        this.expanded = new EventEmitter();
    }
    get isFirst() { return this._isFirst; }
    set isFirst(value) { this._isFirst = coerceBooleanProperty(value); }
    get isLarge() { return this._isLarge; }
    set isLarge(value) { this._isLarge = coerceBooleanProperty(value); }
    get isCompactFields() { return this._isCompactFields; }
    set isCompactFields(value) { this._isCompactFields = coerceBooleanProperty(value); }
    get isVerticalFields() { return this._isVerticalFields; }
    set isVerticalFields(value) { this._isVerticalFields = coerceBooleanProperty(value); }
    get isHighlighted() { return this._isHighlighted; }
    set isHighlighted(value) { this._isHighlighted = coerceBooleanProperty(value); }
    get isExpandable() { return this._isExpandable; }
    set isExpandable(value) { this._isExpandable = coerceBooleanProperty(value); }
    get isExpanded() { return this._isExpanded; }
    set isExpanded(value) { this._isExpanded = coerceBooleanProperty(value); }
    ngAfterContentInit() {
        let stateClass = '';
        let headerStateClass = '';
        if (this.isFirst) {
            stateClass += 'ux-fieldset--first ';
        }
        if (this.isLarge) {
            stateClass += 'ux-fieldset--large ';
        }
        if (this.isExpandable) {
            headerStateClass += 'ux-fieldset__header--expandable';
        }
        this.stateClass = stateClass;
        this.headerStateClass = headerStateClass;
    }
    onToggle(event) {
        if (this.isExpandable) {
            this.isExpanded = !this.isExpanded;
            this.expanded.emit(this.id);
        }
    }
}
/** @nocollapse */ UxFieldsetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFieldsetComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ UxFieldsetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: UxFieldsetComponent, selector: "ux-fieldset", inputs: { id: "id", label: "label", typeClass: "typeClass", iconClass: "iconClass", labelWidthClass: "labelWidthClass", inputWidthClass: "inputWidthClass", styleClass: "styleClass", isFirst: "isFirst", isLarge: "isLarge", isCompactFields: "isCompactFields", isVerticalFields: "isVerticalFields", isHighlighted: "isHighlighted", isExpandable: "isExpandable", isExpanded: "isExpanded", e2eAttr: "e2eAttr" }, outputs: { expanded: "expanded" }, queries: [{ propertyName: "customLabelRightContent", first: true, predicate: i0.forwardRef(function () { return UxFieldsetLabelRightContentTagDirective; }), descendants: true }, { propertyName: "customLabelExtraContent", first: true, predicate: i0.forwardRef(function () { return UxFieldsetLabelExtraContentTagDirective; }), descendants: true }], ngImport: i0, template: `
        <div id="{{id}}" class="ux-fieldset {{styleClass}} {{stateClass}}"
             [class.ux-fieldset--highlighted]="isHighlighted"
             attr.data-e2e="{{ e2eAttr }}">
            <div *ngIf="label" class="ux-fieldset__header {{headerStateClass}}" (click)="onToggle($event)">
                <div class="ux-fieldset__header-label ux-u-color-{{ typeClass }}">
                    <span *ngIf="iconClass" class="ux-fieldset__header-icon {{ iconClass }}"></span>
                    {{ label }}
                    <ng-content select="uxFieldsetLabelExtraContent"></ng-content>
                </div>
                <div class="ux-fieldset__header-right-content">
                    <ng-template [ngIf]="customLabelRightContent">
                        <ng-content select="uxFieldsetLabelRightContent"></ng-content>
                    </ng-template>
                    <span *ngIf="isExpandable"
                          class="ux-fieldset__header-expand-toggle eui-icon"
                          [ngClass]="{'eui-icon-angle-right': !isExpanded, 'eui-icon-angle-down': isExpanded}">
                    </span>
                </div>
            </div>
            <div *ngIf="isExpanded" class="ux-fieldset__content">
                <ng-content></ng-content>
            </div>
        </div>
        <ux-overlay [isActive]="isHighlighted"></ux-overlay>
    `, isInline: true, styles: [".ux-fieldset{margin-bottom:var(--eui-base-spacing-s);position:relative}.ux-fieldset__header{align-items:center;border-bottom:1px solid var(--eui-base-color-grey-20);display:flex;margin-bottom:var(--eui-base-spacing-s);padding-bottom:var(--eui-base-spacing-s);text-transform:uppercase}.ux-fieldset__header-icon{font-size:var(--eui-base-font-size);margin-right:var(--eui-base-spacing-xs)}.ux-fieldset__header-label{align-items:center;display:inline-flex;font-size:var(--eui-base-font-size-s);font-style:normal;font-weight:700}.ux-fieldset__header-right-content{align-items:center;display:flex;margin-left:auto}.ux-fieldset__header-expand-toggle{cursor:pointer;font-size:var(--eui-base-font-size-xl);margin-left:var(--eui-base-spacing-m)}.ux-fieldset__header--expandable{cursor:pointer}.ux-fieldset--large>.ux-fieldset__header>.ux-fieldset__header-label{color:var(--eui-base-color-grey-100);font-size:var(--eui-base-font-size-l);text-transform:none;font-style:normal;font-weight:300}.ux-fieldset--first{margin-top:var(--eui-base-spacing-s)}.ux-fieldset--highlighted{background-color:var(--eui-base-color-white);padding:var(--eui-base-spacing-s);z-index:var(--eui-base-z-index-highlighted)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.UxOverlayComponent, selector: "ux-overlay", inputs: ["styleClass", "isActive", "e2eAttr"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFieldsetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ux-fieldset', template: `
        <div id="{{id}}" class="ux-fieldset {{styleClass}} {{stateClass}}"
             [class.ux-fieldset--highlighted]="isHighlighted"
             attr.data-e2e="{{ e2eAttr }}">
            <div *ngIf="label" class="ux-fieldset__header {{headerStateClass}}" (click)="onToggle($event)">
                <div class="ux-fieldset__header-label ux-u-color-{{ typeClass }}">
                    <span *ngIf="iconClass" class="ux-fieldset__header-icon {{ iconClass }}"></span>
                    {{ label }}
                    <ng-content select="uxFieldsetLabelExtraContent"></ng-content>
                </div>
                <div class="ux-fieldset__header-right-content">
                    <ng-template [ngIf]="customLabelRightContent">
                        <ng-content select="uxFieldsetLabelRightContent"></ng-content>
                    </ng-template>
                    <span *ngIf="isExpandable"
                          class="ux-fieldset__header-expand-toggle eui-icon"
                          [ngClass]="{'eui-icon-angle-right': !isExpanded, 'eui-icon-angle-down': isExpanded}">
                    </span>
                </div>
            </div>
            <div *ngIf="isExpanded" class="ux-fieldset__content">
                <ng-content></ng-content>
            </div>
        </div>
        <ux-overlay [isActive]="isHighlighted"></ux-overlay>
    `, encapsulation: ViewEncapsulation.None, styles: [".ux-fieldset{margin-bottom:var(--eui-base-spacing-s);position:relative}.ux-fieldset__header{align-items:center;border-bottom:1px solid var(--eui-base-color-grey-20);display:flex;margin-bottom:var(--eui-base-spacing-s);padding-bottom:var(--eui-base-spacing-s);text-transform:uppercase}.ux-fieldset__header-icon{font-size:var(--eui-base-font-size);margin-right:var(--eui-base-spacing-xs)}.ux-fieldset__header-label{align-items:center;display:inline-flex;font-size:var(--eui-base-font-size-s);font-style:normal;font-weight:700}.ux-fieldset__header-right-content{align-items:center;display:flex;margin-left:auto}.ux-fieldset__header-expand-toggle{cursor:pointer;font-size:var(--eui-base-font-size-xl);margin-left:var(--eui-base-spacing-m)}.ux-fieldset__header--expandable{cursor:pointer}.ux-fieldset--large>.ux-fieldset__header>.ux-fieldset__header-label{color:var(--eui-base-color-grey-100);font-size:var(--eui-base-font-size-l);text-transform:none;font-style:normal;font-weight:300}.ux-fieldset--first{margin-top:var(--eui-base-spacing-s)}.ux-fieldset--highlighted{background-color:var(--eui-base-color-white);padding:var(--eui-base-spacing-s);z-index:var(--eui-base-z-index-highlighted)}\n"] }]
        }], propDecorators: { id: [{
                type: Input
            }], label: [{
                type: Input
            }], typeClass: [{
                type: Input
            }], iconClass: [{
                type: Input
            }], labelWidthClass: [{
                type: Input
            }], inputWidthClass: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], isFirst: [{
                type: Input
            }], isLarge: [{
                type: Input
            }], isCompactFields: [{
                type: Input
            }], isVerticalFields: [{
                type: Input
            }], isHighlighted: [{
                type: Input
            }], isExpandable: [{
                type: Input
            }], isExpanded: [{
                type: Input
            }], e2eAttr: [{
                type: Input
            }], expanded: [{
                type: Output
            }], customLabelRightContent: [{
                type: ContentChild,
                args: [forwardRef(() => UxFieldsetLabelRightContentTagDirective)]
            }], customLabelExtraContent: [{
                type: ContentChild,
                args: [forwardRef(() => UxFieldsetLabelExtraContentTagDirective)]
            }] } });
/* eslint-disable */
class UxFieldsetLabelRightContentTagDirective {
}
/** @nocollapse */ UxFieldsetLabelRightContentTagDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFieldsetLabelRightContentTagDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ UxFieldsetLabelRightContentTagDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: UxFieldsetLabelRightContentTagDirective, selector: "uxFieldsetLabelRightContent", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFieldsetLabelRightContentTagDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'uxFieldsetLabelRightContent' }]
        }] });
class UxFieldsetLabelExtraContentTagDirective {
}
/** @nocollapse */ UxFieldsetLabelExtraContentTagDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFieldsetLabelExtraContentTagDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ UxFieldsetLabelExtraContentTagDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: UxFieldsetLabelExtraContentTagDirective, selector: "uxFieldsetLabelExtraContent", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFieldsetLabelExtraContentTagDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'uxFieldsetLabelExtraContent' }]
        }] });
/* eslint-enable */
class UxFieldsetComponentModule {
}
/** @nocollapse */ UxFieldsetComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFieldsetComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxFieldsetComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxFieldsetComponentModule, declarations: [UxFieldsetComponent, UxFieldsetLabelRightContentTagDirective, UxFieldsetLabelExtraContentTagDirective], imports: [CommonModule, UxOverlayComponentModule], exports: [UxFieldsetComponent, UxFieldsetLabelRightContentTagDirective, UxFieldsetLabelExtraContentTagDirective] });
/** @nocollapse */ UxFieldsetComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFieldsetComponentModule, imports: [CommonModule, UxOverlayComponentModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFieldsetComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, UxOverlayComponentModule],
                    exports: [UxFieldsetComponent, UxFieldsetLabelRightContentTagDirective, UxFieldsetLabelExtraContentTagDirective],
                    declarations: [UxFieldsetComponent, UxFieldsetLabelRightContentTagDirective, UxFieldsetLabelExtraContentTagDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { UxFieldsetComponent, UxFieldsetComponentModule, UxFieldsetLabelExtraContentTagDirective, UxFieldsetLabelRightContentTagDirective };
